var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from 'syf-component-library/ui/spacing/Stack/Stack';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { CLIHeadingText, CenteredContainer, ContainerContent, Image, SubTitle, Text } from '../../subcomponents';
import CreditLimitDetails from '../../credit-limit-details';
import { translate } from '../../../../strings/i18n';
var BaseMessage = function (_a) {
    var newCreditLimit = _a.newCreditLimit, image = _a.image, title = _a.title, subTitle = _a.subTitle, subText = _a.subText, currentCreditLimit = _a.currentCreditLimit, id = _a.id;
    return (_jsx(CenteredContainer, __assign({ id: id, "data-cy": "base-message-container" }, { children: _jsxs(ContainerContent, { children: [_jsx(Stack, { size: "xlarge" }), image && _jsx(Image, { src: image, alt: "cli-status-image" }), _jsx(Inset, __assign({ top: "large", bottom: "small" }, { children: title && _jsx(CLIHeadingText, { children: title }) })), subTitle && _jsx(SubTitle, { children: subTitle }), _jsx(Stack, { size: "base" }), newCreditLimit && (_jsx(CreditLimitDetails, { creditLimitAmount: translate('modal.creditLimit', {
                        creditLimit: "".concat(newCreditLimit)
                    }), displayText: translate('cliSuccess.newLimit') })), currentCreditLimit && (_jsx(CreditLimitDetails, { creditLimitAmount: translate('modal.creditLimit', {
                        creditLimit: "".concat(currentCreditLimit)
                    }), displayText: translate('modal.currentCreditLimit') })), _jsx(Inset, __assign({ horizontal: "small" }, { children: subText && _jsx(Text, __assign({ centered: true }, { children: subText })) }))] }) })));
};
export default BaseMessage;
